<template>
	<el-dialog :title="'线下文件上传'" :close-on-click-modal="false" :visible.sync="subVisible" width="700px">
		<el-form>
			<el-row>
				<el-col :span="2">
					<span>
						周报
					</span>
				</el-col>
				<el-col :span="21" v-if="dataForm.offlineFilePathUri" style="margin:-8px 0 10px 7px;">
					<el-col :span="19">
						<el-button v-preventReClick type="text" size="small" style="color: #00428e;"
							@click="viewPdf(dataForm.offlineFilePath, dataForm.offlineFilePathUri, dataForm.fileName)">
							{{ dataForm.fileName }}
						</el-button>
					</el-col>
					<el-col :span="5">
						<el-button v-preventReClick type="text" size="small"
							@click="downloadFile('0', dataForm.offlineFilePathUri, dataForm.fileName)"
							style="margin-left: 20px; ">查看</el-button>
						<el-button v-preventReClick type="text" size="small" @click="delOfflineFile()">删除</el-button>
					</el-col>
				</el-col>
				<el-col :span="22" v-else>
					<el-upload ref="uploadWeeklyOfflineFile" class="upload-demo" action="action" drag
						:http-request="uploadWeeklyOfflineFile" :show-file-list=false :auto-upload="true"
						style="margin-left: 10px;">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					</el-upload>
				</el-col>
			</el-row>
		</el-form>
		<el-row>
			<el-col :span="2">
				<span>
					附件
				</span>
			</el-col>
			<el-col :span="22">
				<el-upload ref="uploadScanEncolsureFile" class="upload-demo" action="action" drag
					:http-request="uploadScanEncolsureFile" :show-file-list=false :auto-upload="true"
					style="margin-left: 10px;" multiple>
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				</el-upload>
			</el-col>
		</el-row>
		<el-row v-for="(enclosureFile, index) in dataForm.enclosureFileList" :key="'enclosure' + index"
			style="margin-top: 10px;">
			<el-col :span="24" v-if="dataForm.enclosureFileList">
				<span style="margin: 0 25px 0 20px;"">{{ index + 1 }}</span>
				<el-input v-model="enclosureFile.fileName" placeholder="请填写名称"
					style="width: 435px;margin-left: 10px;font-size: small;"></el-input>
					<el-button v-preventReClick type="text" size="small"
						@click="downloadFile('1', enclosureFile.filePathUri, enclosureFile.fileName)"
						style="margin-left: 20px; ">查看</el-button>
					<el-button v-preventReClick type="text" size="small"
						@click="deleteEncolsureFile(index)">删除</el-button>
			</el-col>
		</el-row>
		<el-row class="formBtnGroup">
			<el-button v-preventReClick class="btn" type="primary" size="small" style="margin-top: 10px;"
				@click="dataFormSubmit">保
				存</el-button>
		</el-row>
		<view-pdf v-if="viewPdfVisible" ref="viewPdf"></view-pdf>
	</el-dialog>
</template>

<script>
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js"
import ViewPdf from "../projectInfo/viewPdf.vue"
import { Message } from 'element-ui';
export default {
	name: "weekly-file-upload",
	data() {
		return {
			viewPdfVisible: false,
			addImg: addImg,
			id: "",
			subVisible: true,
			form: {},
			action: "",
			fileType: "",
			dataForm: {
				recNo: '',
				weeklyName: '',
				fileName: "",
				filePath: "",
				enclosureFileList: '',
			},
			dataRule: {
				weeklyName: [
					{ required: true, message: "周报名称不能为空！", trigger: "blur" }
				],
			}
		};
	},
	components: {
		ViewPdf
	},
	activated() {

	},
	methods: {
		init(id) {
			this.dataForm = {
				recNo: '',
				weeklyName: '',
				filePath: '',
				filePathUri: '',
				offlineFilePath: '',
				offlineFilePathUri: '',
				fileName: '',
				enclosureFileList: [],
				weekKind: ''
			}
			this.dataForm.recNo = id
			this.getDetail();
			this.$nextTick(() => {
				this.subVisible = true;
			})
		},
		viewReportFile() {
			window.open(this.dataForm.offlineFilePathUri);
		},
		viewEncolsureFile(index) {
			window.open(this.dataForm.enclosureFileList[index].filePathUri);
		},
		viewPdf(filePath, fileUri, filename) {
			// pdf和doc文件，需要pdf在线预览，其他类型文件直接下载
			let suffixType = fileUri.substr(fileUri.lastIndexOf(".") + 1)
			if (suffixType != '' && (suffixType === 'pdf' || suffixType === 'doc' || suffixType === 'docx')) {
				// $common.viewFile(filePath)
				this.viewPdfVisible = true;
				this.$nextTick(() => {
					this.$refs.viewPdf.init(filename, filePath)
				})
			} else {
				filename = this.getSuffix(fileUri, filename)
				this.getBlob(fileUri, (blob) => {
					this.saveAs(blob, filename)
				})
			}
		},
		downloadFile(type, fileUri, filename) {
			filename = this.getSuffix(fileUri, filename)
			this.getBlob(fileUri, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		getSuffix(url, filename) {
			// 正则匹配：判断文件名是否包含 .后缀名（支持常见后缀，且不是最后一个字符）
			const hasSuffix = /\.[a-zA-Z0-9]+$/.test(filename);
			// 如果已经有后缀，直接返回原文件名；没有则拼接URL里的后缀
			if (hasSuffix) {
				return filename;
			}
			// 没有后缀，执行原逻辑拼接
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex);
		},
		getBlob(url, cb) {
			const rLoading = this.openLoading();
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
					rLoading.close();
				} else if (xhr.status === 404) {
					rLoading.close();
					Message.error('文件不存在')
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
		getDetail() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectweeklyreportinfo/getWeeklyEnclosureFileList/" + this.dataForm.recNo,
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm.weeklyName = data.body.weeklyName;
					this.dataForm.filePath = data.body.filePath;
					this.dataForm.filePathUri = data.body.filePathUri;
					this.dataForm.offlineFilePath = data.body.offlineFilePath;
					this.dataForm.offlineFilePathUri = data.body.offlineFilePathUri;
					this.dataForm.fileName = data.body.fileName;
					this.dataForm.enclosureFileList = data.body.enclosureFileList;
					this.dataForm.weekKind = data.body.weekKind;
				}
			});
		},
		uploadWeeklyOfflineFile(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadWeeklyOfflineFile.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/87/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data;
				if (res.resultCode === 200) {
					this.dataForm.offlineFilePath = res.body.fileSavePath
					this.dataForm.offlineFilePathUri = res.body.fileUri
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		delOfflineFile() {
			this.dataForm.offlineFilePath = ''
			this.dataForm.offlineFilePathUri = ''
		},
		deleteEncolsureFile(index) {
			this.dataForm.enclosureFileList.splice(index, 1);
		},
		uploadScanEncolsureFile(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadScanEncolsureFile.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/91/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode === 200) {
					if (this.dataForm.enclosureFileList.length >= 10) {
						this.$message.error('最多只能上传10个附件！');
						return;
					}
					// 判断文件名称是否存在
					let exist = this.checkFileNameExist(res.body.fileName);
					if (exist) {
						this.$message.error("文件名称已存在");
						return;
					}
					let enclosureFile = {
						fileName: res.body.fileName,
						filePath: res.body.fileSavePath,
						filePathUri: res.body.fileUri,
						weeklyRecNo: this.dataForm.recNo,
						recNo: '',
						dataType: '080000',
						souceType: '',
						sourceId: '',
						dataKind: '1'
					}
					this.dataForm.enclosureFileList.push(enclosureFile);
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		checkFileNameExist(fileName) {
			let enclosureFileList = this.dataForm.enclosureFileList;
			if (enclosureFileList) {
				for (var i = 0; i < enclosureFileList.length; i++) {
					if (enclosureFileList[i].fileName === fileName) {
						return true;
					}
				}
			}
			return false;
		},
		dataFormSubmit() {
			// if (!this.dataForm.offlineFilePath || !this.dataForm.fileName) {
			// 	this.$message.error("未上传周报正文");
			// 	return;
			// }
			let _url = "/business/projectweeklyreportinfo/updateReportFiles";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: this.dataForm.recNo,
					workNo: $common.getItem("workNo"),
					weeklyName: this.dataForm.weeklyName,
					filePath: this.dataForm.filePath,
					offlineFilePath: this.dataForm.offlineFilePath,
					fileName: this.dataForm.fileName,
					enclosureFileList: this.dataForm.enclosureFileList,
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.subVisible = false;
							this.$emit("refreshDataList");
						}
					});
				} else {
					this.$message.error(data.msg);
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
.selItemInput.descAreaLg {
	width: 1030px !important;
}

.addImgBox {
	width: 136px;
	height: 136px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
	position: relative;
}

.el-divider {
	margin: 60px 0;
	background: 0 0;
	border-top: 1px solid #E6EBF5;
}

.tmp {
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	width: 358px;
	display: inline-block;
	color: #00428e;
}

/* 正常上传框大小 */
::v-deep .upload-demo .el-upload-dragger {
	width: 520px !important;
	height: 80px !important;
}

::v-deep .upload-demo .el-upload-dragger .el-icon-upload {
	font-size: 30px !important;
	margin: 12px 0 !important;
}

::v-deep .upload-demo .el-upload-dragger .el-upload__text {
	line-height: 1.2 !important;
}
</style>
